import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn } from "typeorm";
import { Brand } from "./brand.entity";
import { CommonColumns } from "./common-columns.entity";

@Entity()
export class Company extends CommonColumns {

  @Column({ length: 100, })
  name: string;

  @OneToMany(() => Brand, brand => brand.company)
  brands: Brand[];

  constructor(props: TCompany) {
    super();
    Object.assign(this, props);
  }
}

export declare type TCompany = Omit<Company, 'dummy-no-such-field'>;
export interface ICompany extends TCompany {};
